<template>
  <div class="">
    <div class="mobile-status-padding"></div>
    <div class="flex justify-between items-center">
      <slot name="headerLeft">
        <div class="w-full flex justify-start min-w-12">
          <button
            @click="$emit('backClicked')"
            class="w-10 h-10 bg-white p-2 min-w-10 rounded-full font-bold text-3xl flex items-center justify-center"
          >
            <ColorImg
              src="/images/icons/arrow-up.svg"
              class="w-full h-full bg-gray-500 -rotate-90"
              alt="Calendar"
            />
          </button>
        </div>
      </slot>
      <slot name="headerCenter">
        <div class="w-full text-3xl title-color text-center font-bold">
          <slot name="default"> - </slot>
        </div>
      </slot>
      <slot name="headerRitht">
        <div class="w-full"></div>
      </slot>
    </div>
  </div>
</template>
